import templateUrl from './edit-bulletin.component.html'

export const EditBulletinComponent = {
    templateUrl,
    controller: EditBulletinController,
    controllerAs: "vm",
    bindings: {
        resolve: "<",
        close: "&",
        dismiss: "&"
    }
}

export const EditBulletinModal = {
    windowClass: 'xx-dialog pagespinner',
    component: "apexEditBulletin",
    templateUrl: "Scripts/Page/Message/edit-bulletin.html",
    controller: 'EditBulletinController',
    controllerAs: "vm",
    size: 'lg',
    backdrop: 'static',
}

function EditBulletinController($q, utilityService, messageService,
    roleService, icdCorporationService, employeeService) {
    'ngInject'

    const vm = this;
    vm.bulletin;
    vm.icdCorporations;
    vm.roles;
    vm.employees = [];
    vm.bulletinEmployees = [];
    vm.recipients = [];
    vm.$onInit = onInit;
    vm.minLengthToSearchEmployee = 3;
    vm.loaded = false;
    vm.selectOptions = {
        dataSource: {
            transport: {
                read: handleRecipientDataSourceRead
            },
            serverFiltering: true,
        },
        dataTextField: 'Text',
        dataValueField: 'Value'
    };

    vm.messageTypeSelectOptions = {
        dataSource: {
            transport: {
                read: handleMessageTypeDataSourceRead
            }
        },
        dataTextField: 'Name',
        dataValueField: 'MessageTypeID',
        optionLabel: {
            MessageTypeID: null,
            Name: "Select Message Type"
        }
    };

    vm.handleSave = handleSave;
    vm.handleCancel = handleCancel;

    function onInit() {
        vm.bulletinID = vm.resolve.bulletinID
        if (vm.bulletinID) {

            // Load an existing bulletin.
            utilityService.showLoading();
            messageService.retrieveBulletin(vm.bulletinID)
                .then(function (bulletin) {
                    vm.bulletin = bulletin;
                })
                .then(loadRoles)
                .then(loadIcdCorporations)
                .then(loadBulletinEmployees)
                .then(function (bulletinEmployees) {
                    vm.loaded = true;
                    vm.bulletinEmployees = bulletinEmployees;
                })

                .catch(function (ex) {
                    alert("initial load failed: " + (ex.statusText || ex));
                })
                .then(function () {
                    utilityService.hideLoading();
                });
        } else {
            utilityService.showLoading();
            loadRoles()
                .then(loadIcdCorporations)
                .then(function () {
                    vm.loaded = true;
                    utilityService.hideLoading();
                });
            vm.bulletin = { FormatHTML: true };

        }
    }

    function handleRecipientDataSourceRead(e) {
        loadBulletinRecipients(e.data.filter)
            .then(function (recipients) {
                e.success(recipients);
            })
            .catch(function (ex) {
                e.error(ex);
            });
    }

    function handleMessageTypeDataSourceRead(e) {
        loadMessageTypes()
            .then(function (messageTypes) {
                e.success(messageTypes);
            })
            .catch(function (ex) {
                e.error(ex);
            });
    }

    function loadBulletinRecipients(filter) {
        const searchFilter = filter ? filter.filters[0] : null;
        const searchValue = searchFilter ? searchFilter.value : "";

        return $q.all([loadEmployees(searchFilter, true)])
            .then(function (v) {

                // Map each type of employee into a generic form that can
                // be combined in the multiselect picker.
                const roleRecipients = vm.roles.filter(function (event) {
                    return utilityService.containsInvariant(event.Name, searchValue);
                }).map(function (role) {
                    return {
                        Type: "role",
                        Value: role.Id,
                        Text: role.Name
                    };
                });

                const filteredBulletinEmployees =
                    vm.bulletinEmployees.filter(function (employee) {
                        return utilityService.containsInvariant(employee.FirstLastName, searchValue);
                    });

                const employees = addBulletinEmployeeIfNotExists(filteredBulletinEmployees, v[0]);
                const employeeRecipients = employees.map(function (employee) {
                    return {
                        Type: "employee",
                        Value: employee.Id,
                        Text: employee.FirstName + " " + employee.LastName
                    };
                });

                const icdCorporationRecipients = vm.icdCorporations.filter(function (event) {
                    return utilityService.containsInvariant(event.ClientName, searchValue)
                }).map(function (icdCorporation) {
                    return {
                        Type: "corporation",
                        Value: icdCorporation.Id,
                        Text: icdCorporation.ClientName
                    };
                });
                vm.recipients = roleRecipients
                    .concat(icdCorporationRecipients)
                    .concat(employeeRecipients);

                return vm.recipients;
            });
    }

    function loadRoles() {
        return roleService.retrieveRoles()
            .then(function (roles) {
                vm.roles = roles;
                return roles;
            });
    }

    function loadIcdCorporations() {
        return icdCorporationService.retrieveIcdCorporations()
            .then(function (icdCorporations) {
                vm.icdCorporations = icdCorporations;
                return icdCorporations;
            });
    }

    function loadBulletinEmployees() {
        const employees = vm.bulletin.Recipients.filter(function (event) {
            return event.Type === "employee"
        }).map(function (employee) {
            return employee.Value;
        });

        return employees.length > 0 ? loadEmployees({ EmployeeIDs: employees }, false) : [];
    }

    function loadEmployees(filter, checkLength) {
        if (filter && (!checkLength || filter.value.length >= vm.minLengthToSearchEmployee)) {
            return employeeService.retrieveEmployees({ FullName: filter.value, EmployeeIDs: filter.EmployeeIDs })
                .then(function (employees) {
                    employees.forEach(function (employee) {
                        employee.FirstLastName = employee.FirstName + " " + employee.LastName;
                    });
                    vm.employees = employees;
                    return employees;
                });
        }
        return [];
    }

    function addBulletinEmployeeIfNotExists(bulletinEmployees, destinationEmployees) {
        bulletinEmployees.forEach(function (bulletinEmployee) {
            const exists = destinationEmployees.filter(function (destinationEmployee) {
                return destinationEmployee.Id === bulletinEmployee.Id
            })[0];
            if (!exists) {
                destinationEmployees.push(bulletinEmployee);
            }
        });
        return destinationEmployees;
    }

    function loadMessageTypes() {
        return messageService.retrieveMessageTypes()
            .then(function (messageTypes) {
                vm.messageTypes = messageTypes;
                return messageTypes;
            })
    }

    function handleSave() {
        utilityService.showLoading();
        (function () {
            if (!vm.bulletinID) {
                return messageService.createBulletin(vm.bulletin);
            } else {
                return messageService.updateBulletin(vm.bulletinID, vm.bulletin);
            }
        })()
            .then(function () {
                vm.close();
            })
            .catch(function (ex) {
                alert("Saving the bulletin failed: " + (ex.statusText || ex))
            })
            .then(function () {
                utilityService.hideLoading();
            });
    }

    function handleCancel() {
        vm.dismiss({ $value: 'cancel' });
    }
}
